export default  function formatMediaUrl(url): string {
  if (url && url.indexOf('http') == 0) {
    return url
  } else {
    return url ? (process.env.VUE_APP_MEDIAS_BASE || '') + url : ''
  }
 }